import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import { withTranslation } from 'react-i18next';

class Reward extends Component {
    render() {
        const { t } = this.props;
        const highlights = [
            { icon: "⭐", label: "ดาว", text: t('reward.item1') },
            { icon: "🌐", label: "โลก", text: t('reward.item2') },
            { icon: "🏅", label: "เหรียญรางวัล", text: t('reward.item3') },
            { icon: "🏆", label: "ถ้วยรางวัล", text: t('reward.item4') },
            { icon: "🏆", label: "ถ้วยรางวัล", text: t('reward.item5') },
            { icon: "👏", label: "ปรบมือ", text: t('reward.item6') },
            { icon: "☕", label: "กาแฟ", text: t('reward.item7') },
            { icon: "📺", label: "โทรทัศน์", text: t('reward.item8') },
            { icon: "🎥", label: "กล้องถ่ายทำ", text: t('reward.item9') },
            { icon: "📹", label: "วิดีโอ", text: t('reward.item10') },
            { icon: "💍", label: "แหวน", text: t('reward.item11') },
            { icon: "🎶", label: "ดนตรี", text: t('reward.item12') },
        ];

        const awardMedia = [
            { src: "/assets/images/contact/reward-1.webp", alt: t('reward.alt1') },
            { src: "/assets/images/contact/reward-2.webp", alt: t('reward.alt2') },
            { src: "/assets/images/contact/MSMEAWARD.png", alt: t('reward.alt3') },
        ];

        return (
            <React.Fragment>
                <PageHelmet 
                    pageTitle={t('reward.pageTitle')} 
                    description={t('reward.metaDescription')}
                    keywords={t('reward.metaKeywords')}
                    siteName={t('common.siteName')}
                />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                <div className="reward-page bg_color--1">
                    <section className="reward-hero">
                        <div className="container">
                            <div className="row align-items-center row--20">
                                <div className="col-lg-7 col-md-12">
                                    <div className="reward-hero-content">
                                        <div className="reward-kicker">Awards & Recognition</div>
                                        <h1 className="reward-title">{t('reward.title')}</h1>
                                        <p className="reward-subtitle">{t('reward.metaDescription')}</p>
                                        <div className="reward-hero-actions">
                                            <a className="btn-default" href="/about">About</a>
                                            <a className="btn-default btn-border" href="/contract">Contact</a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-12">
                                    <div className="reward-hero-media">
                                        <div className="reward-hero-media-grid">
                                            {awardMedia.map((m) => (
                                                <div className="reward-media-tile" key={m.src}>
                                                    <img src={m.src} alt={m.alt} loading="lazy" />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="reward-section">
                        <div className="container">
                            <div className="reward-section-head">
                                <h2 className="reward-section-title">{t('reward.pageTitle')}</h2>
                                <p className="reward-section-desc">สรุปไฮไลต์รางวัล การรับรอง และการยอมรับที่สำคัญ</p>
                            </div>

                            <div className="row row--20 reward-highlight-grid">
                                {highlights.map((h, idx) => (
                                    <div className="col-lg-4 col-md-6 col-sm-12 reward-highlight-col" key={idx}>
                                        <article className="reward-highlight-card">
                                            <div className="reward-highlight-icon" aria-hidden="true">{h.icon}</div>
                                            <div className="reward-highlight-text">
                                                <div className="reward-highlight-title">{h.text}</div>
                                            </div>
                                        </article>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    <section className="reward-section reward-timeline-section">
                        <div className="container">
                            <div className="reward-section-head">
                                <h2 className="reward-section-title">{t('reward.timelineTitle')}</h2>
                                <p className="reward-section-desc">ไทม์ไลน์กิจกรรมสำคัญและหมุดหมายที่น่าจดจำ</p>
                            </div>

                            <div className="reward-timeline">
                                <div className="reward-timeline-item">
                                    <div className="reward-timeline-year">{t('reward.timeline1')}</div>
                                    <div className="reward-timeline-card">{t('reward.timeline1Event')}</div>
                                </div>
                                <div className="reward-timeline-item">
                                    <div className="reward-timeline-year">{t('reward.timeline2')}</div>
                                    <div className="reward-timeline-card">{t('reward.timeline2Event')}</div>
                                </div>
                                <div className="reward-timeline-item">
                                    <div className="reward-timeline-year">{t('reward.timeline3')}</div>
                                    <div className="reward-timeline-card">{t('reward.timeline3Event')}</div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="container">
                        {/* reserved: keep container spacing consistent with theme */}
                    </div>
                </div>

                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
            </React.Fragment>
        )
    }
}
export default withTranslation()(Reward);
